
<template>
  <div>
    <IndexPaymentOptions></IndexPaymentOptions>
  </div>
</template>

<script>

export default {
  name: 'Payments',
  components: {
    IndexPaymentOptions: () => import("@/_backoffice/_registrations/components/payment_option/IndexPaymentOptions.vue")
  },
}
</script>

<style scoped>

</style>